var _path, _path2, _path3, _path4, _g, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2649_39179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0032 5.33163H15.7857C9.99422 5.44719 5.33792 10.1783 5.33792 15.9969C5.33792 21.8156 9.99422 26.5467 15.7857 26.6622H16.0032H16.2208C21.9443 26.5467 26.553 21.938 26.6685 16.2145V15.9969V15.7794C26.553 9.98792 21.8287 5.33163 16.0032 5.33163ZM15.9964 2.66699H16.2276C23.4057 2.78935 29.2108 8.58083 29.3332 15.7658V16.0037V16.2348C29.2108 23.413 23.4125 29.2113 16.2276 29.3337H15.9897H15.7585C8.49878 29.2113 2.6665 23.2907 2.6665 16.0037C2.6665 8.7168 8.62795 2.6738 15.9897 2.6738L15.9964 2.66699Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2649_39179)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2649_39179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -501,
    y: -267,
    width: 871,
    height: 545
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M369.719 -266.65H-500.363V277.151H369.719V-266.65Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2649_39179)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2649_39179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -3,
    width: 38,
    height: 38
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6012 -2.90625H-2.78516V34.4801H34.6012V-2.90625Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2649_39179)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2649_39179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 28,
    height: 28
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8429 2.53223H2.65283V29.7223H29.8429V2.53223Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2649_39179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2058 -3.19824H-3.19336V35.2009H35.2058V-3.19824Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6735 -5.66602H-5.66748V37.6749H37.6735V-5.66602Z",
    fill: "#151515"
  })))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4852 9.33496H14.5215L14.9158 17.2337H17.023L17.4852 9.33496Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9894 18.7158H15.8738C14.8406 18.777 14.0249 19.6539 14.0249 20.7007C14.0249 21.7475 14.8338 22.5972 15.8738 22.6584H15.9894H16.1049C17.1246 22.5972 17.9131 21.7951 17.9675 20.8162V20.7007V20.5851C17.9063 19.5451 17.0566 18.7158 15.9826 18.7158H15.9894Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.468a7f6a6ec15fb195688daf5049035a.svg";
export { ForwardRef as ReactComponent };